import DashboardSchema from 'schemas/DashboardSchema'
import DashboardInfoSchema from 'schemas/DashboardInfoSchema'

export function DashboardVo(initData = {}) {
  return DashboardSchema.validateSync(initData)
}

export function DashboarInfodVo(initData = {}) {
  return DashboardInfoSchema.validateSync(initData)
}
